import { Injectable } from "@angular/core";
import { HttpService } from "src/app/core/service/http.service";
import { UserIdleService } from "angular-user-idle";

@Injectable({
  providedIn: "root",
})
export class PatientService {
  constructor(
    private httpService: HttpService,
    private userIdle: UserIdleService
  ) {
    this.restart();
  }

  AddPatient(patientDetails: any) {
    return this.httpService.post("patient/Add", patientDetails);
  }
  UpdatePatient(patientDetails: any) {
    return this.httpService.post("patient/Update", patientDetails);
  }
  ListPatient(patientDetails: any) {
    return this.httpService.post("patient/Get", patientDetails);
  }
  ListPatientForDropdown(patientDetails: any) {
    return this.httpService.post("patient/GetList", patientDetails);
  }
  DeletePatient(patientDetails: any) {
    return this.httpService.post("patient/Delete", patientDetails);
  }
  GetPatient(patientDetails: any) {
    return this.httpService.post("patient/GetById", patientDetails);
  }
  GetPatientListForReport(patientDetails: any) {
    return this.httpService.post("patient/GetPatientDropdown", patientDetails);
  }
  IsPatientExistBySameName(patientDetails: any) {
    return this.httpService.post("patient/IsPatientExist", patientDetails);
  }
  restart() {
    this.userIdle.resetTimer();
  }
}
